<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-28 21:07:21
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-05-11 10:49:55
 * @FilePath: /dsicm-admin-web/src/views/newPatientmanage/components/PatientHome/index.vue
-->
<template>
  <div class="patient-home">
    <div class="chat-container">
      <div class="l-box">
        <!-- 每切换一个患者右侧数据也要相应发生变化 -->
        <div class="right-drawer">
          <span :class="currentActive === 'basic' ? 'active' : ''" @click="drawerChange('basic')">个人基本信息</span>
          <span :class="currentActive === 'basicP' ? 'active' : ''" @click="drawerChange('basicP')">病历基本信息</span>
          <span :class="currentActive === 'logic' ? 'active' : ''" @click="drawerChange('logic')">逻辑生效</span>
        </div>
      </div>
       <!-- 患者基本信息 -->
      <div class="basic-drawer basic-info"  v-if="currentActive === 'basic'">
        <MinUserLeft  ref="basicInfo" @userEdit="userDetailsHandel"  :userDetailsData="patientArchivesLeftVO" :jargonList="jargonList">
        </MinUserLeft>
        <div class="btn">
          <el-button type="primary" v-if="isEdit" plain @click="submitHandel('edite')" size="small">保存</el-button>
          <el-button type="primary" v-else plain @click="submitHandel('save')" size="small">编辑</el-button>
        </div>
      </div>
      <MinUserRight @userEdit="userDetailsHandel" ref="UserRightDetailsRef" v-if="currentActive === 'basicP'"
        :userDetailsData="patientArchivesRightVO" :jargonList="jargonList" :currentActive="currentActive"
        @closeDrawer="closeDrawer" style="margin-right: 0;">
      </MinUserRight>
      <MinLogic v-if="currentActive === 'logic'" :userDetailsData="logicData" :currentActive="currentActive"
        @closeDrawer="closeDrawer" style="margin-right: 0;">
      </MinLogic>
    </div>
  </div>
</template>
<script>
import local from "@/utils/local.js";
import UserLeftDetails from "../UserDetails/userLeft.vue";
import MinUserLeft from "../UserDetails/minUserLeft";
import MinUserRight from "../UserDetails/minUserRight";
import MinLogic from "../UserDetails/minLogic";
import UserRightDetails from "../UserDetails/userRight.vue";
import IM from "../../../treatment/components/IM/IM";
import { getPatientDetailedInformationVO, getListByPatientId } from "../../api";

export default {
  name: "PatientHome",
  props: {
    patientId: {
      type: String,
      default: ""
    }
  },
  components: {
    IM,
    UserLeftDetails,
    MinUserLeft,
    MinUserRight,
    MinLogic,
    UserRightDetails
  },
  data() {
    return {
      isEdit:false,
      positionId: 1,
      tab: 1,
      topHeight: 376,
      currentActive: local.get("tabActiveItem") || "basic", // 存储已选中tab
      patientArchivesLeftVO: {}, // 个人基本信息
      patientArchivesRightVO: {}, // 病历基本信息
      logicData: {}, // 逻辑生效
      // 新增术语
      jargonList: []
    };
  },
  computed: {
    //监听菜单是否收起判断宽度进行展示不同布局
    meunOff() {
      return this.$store.state.isCollapse;
    }
  },
  watch: {
    meunOff: {
      handler(newval, oldVal) {}
    },
    patientId: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.initPatientRightData(
            newValue,
            this.currentActive === "logic" ? 3 : 1
          );
        }
      }
    }
  },
  created() {
    let { patientId } = this.$route.query;
    this.patientId = patientId;
    this.getListByPatientId();
  },
  methods: { 
    //保存基本信息
    submitHandel(val){ 
      if(val == 'edite'){ 
        this.$refs.basicInfo.onEditeBasic('save')  
      }else{
        this.isEdit = true
        this.$refs.basicInfo.onEditeBasic('edite')  
      } 
    },
    // 获取新增字段
    async getListByPatientId() {
      let { code, data } = await getListByPatientId({
        patientId: this.patientId,
        positionId: this.positionId
      });
      if (code === 0) {
        this.jargonList = data ? data : [];
      }
    },
    // 切换展开抽屉弹框
    drawerChange(val) {
      this.currentActive = val;
      local.set("tabActiveItem", val); // 清除local中保存的数据
      if (val === "basic") {
        this.positionId = 1;
        this.getListByPatientId();
      }
      if (val === "basicP") {
        this.positionId = 4;
        this.getListByPatientId();
      }
      if (val === "logic") {
        this.initPatientRightData(this.patientId, 3);
      } else {
        this.initPatientRightData(this.patientId, 1);
      }
    },
    // 关闭抽屉弹框
    closeDrawer(val) {
      this.currentActive = val;
    },
    /**
     * @description: 个人基本信息编写
     * @param {*}
     * @return {*}
     */
    userDetailsHandel(event) {
      this.isEdit = false 
      this.$emit("isEdit", true);
      this.initPatientRightData(this.patientId, event);
      //TODO 当isEdit为false当时候发通知给父组件，提示切换后数据会丢失，
      // if(!event.isEdit){
      //     this.$emit('isEdit',false)
      // }else{
      // // this.$$emit('userDetailsLeftEdit')
      //     //调取保存接口
      // }
    },
    /**
     * @description: 病例基本信息编写
     * @param {*}
     * @return {*}
     */
    caseDetailsHandel(event) {},
    /**
     * @description: 拿患者ID得到右侧所有信息--1.10新接口 type 1个人信息 2入案详情 3逻辑生效 3对照录入 5反馈处理 6打卡异常 7任务提醒
     * @param {* patientId}
     * @return {*}
     */
    async initPatientRightData(patientId, type) {
      if (type == 9) return;
      if (type === true) {
        type = 1;
      }
      let {
        code,
        data: { personalInformationVO, logicVO, kinshipName }
      } = await getPatientDetailedInformationVO({
        patientId: this.patientId,
        type
      });
      if (code === 0) {
        if (personalInformationVO) {
          sessionStorage.setItem(
            "archivesId",
            personalInformationVO.patientArchivesLeftVO.id
          );
        }
        if (this.currentActive === "logic") {
          this.logicData = logicVO.decisionExecutedRecord;
        } else if (this.currentActive === "basic") {
          this.patientArchivesLeftVO =  {
            ...personalInformationVO.patientArchivesLeftVO,
            kinshipName
          };
          // 缓存患者档案id，患者id 供患者病例时间历史记录组件处使用 
          sessionStorage.setItem("linkArchivesId",this.patientArchivesLeftVO.id);
          sessionStorage.setItem("linkPatientId", this.patientArchivesLeftVO.patientId);
        } else if (this.currentActive === "basicP") { 
          this.patientArchivesRightVO = {
            ...personalInformationVO.patientArchivesRightVO,
            assistedReproductionVO: {
              ...personalInformationVO.assistedReproductionVO
            }
          };  
           // 缓存患者档案id，患者id 供患者病例时间历史记录组件处使用
          sessionStorage.setItem("linkArchivesId", this.patientArchivesRightVO.id);
          sessionStorage.setItem( "linkPatientId", this.patientArchivesRightVO.patientId); 
        } 
       
      }
    }
  }
};
</script>
<style>
.basic-info .link-box{
    width: 420px;
 }
</style>
<style scoped lang="less">
.patient-home { 
  height: calc(100% - 140px);
  .chat-container {
    width: 100%; 
    height: 100%; 
    justify-content: flex-start;
    .l-box {
      flex: 1;
      border-radius: 6px; 
      background: #fff;
      .right-drawer {
        display: flex;
        align-items: center; 
        padding: 20px 20px 0; 
        span {
          height: 26px;
          line-height: 26px;
          padding: 0 5px;
          margin-right: 40px;
          border-radius: 4px;
          cursor: pointer;
        }
        .active {
          color: #fff;
          background: #1a7bfc;
        }
      }
    }
    .r-box {
      width: 500px;
    }
    .user-details {
      width: 50%;
      height: 100%;
      background-color: #fff;
      margin-right: 14px;
      border-radius: 6px;
    }
    .ailment-info {
      width: 50%;
      height: 100%;
      background-color: #fff;
      border-radius: 6px;
    }
  }
} 

.basic-info{ 
  position: relative;
  .el-form {
    width: 80%;
  }
  .btn {
    position: absolute;
    right: 35px;
    top: 10px;
    border-radius: 0;
    width: 57px;
    height: 30px; 
    border-radius: 0px 6px 0px 0px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    i {
      font-size: 14px;
    }
    p {
      font-size: 12px;
      margin-left: 4px;
    }
  } 
  .el-form-item {
    padding-right: 16px;
    & /deep/.el-form-item__label {
      font-size: 12px;
      color: #666666;
    }
    & /deep/.el-input-number {
      span {
        display: none;
      }
      input {
        text-align: left;
      }
    }
    & /deep/.el-select {
      width: 100%;
    }
    & /deep/.el-input {
      width: 100%;
    }
    & /deep/.el-input-number--mini {
      width: 100%;
    }
    p {
      font-size: 12px;
      color: #333333;
    }
  }
  .asdsa {
    & /deep/ .el-form-item__label:before {
      content: "";
      margin: 0;
    }
  } 
}

</style>